// Status of a master treatment / lab / medicine & product (BE: MTreatStatus).
// A master starts รอจัดการ until an accountant assigns a Cost G/L (พร้อมใช้งาน);
// only พร้อมใช้งาน rows can be used on patient records.
export const MASTER_STATUS = {
  PENDING: "PENDING",
  READY: "READY",
  CANCELLED: "CANCELLED",
};

export const MASTER_STATUS_LABEL = {
  [MASTER_STATUS.PENDING]: "รอจัดการ",
  [MASTER_STATUS.READY]: "พร้อมใช้งาน",
  [MASTER_STATUS.CANCELLED]: "ยกเลิก",
};

// Same text colour as the other status badges (AdjustmentStatusBadge).
export const MASTER_STATUS_BADGE = {
  [MASTER_STATUS.PENDING]: { backgroundColor: "#F6E8B2", color: "#3E495B" },
  [MASTER_STATUS.READY]: { backgroundColor: "#D8EFDD", color: "#3E495B" },
  [MASTER_STATUS.CANCELLED]: { backgroundColor: "#E9ECEF", color: "#3E495B" },
};

// Rows per request on the accountant pages. The lists are large, so they are
// paged: the next page loads when the user scrolls near the bottom.
export const COST_GL_PAGE_SIZE = 500;

// Tab order on the accountant pages (also the ?tab= keys).
export const COST_GL_TABS = [
  MASTER_STATUS.PENDING,
  MASTER_STATUS.READY,
  MASTER_STATUS.CANCELLED,
];

// A row can be picked for a new patient record only when READY. Rows without a
// status (older payloads / clinics that are not gated) stay selectable.
export function isMasterSelectable(item) {
  return !item || !item.status || item.status === MASTER_STATUS.READY;
}

// Type of a G/L account (BE: MCostGlType). Treatments and items get one of each;
// labs only a cost G/L.
export const GL_TYPE = {
  COST: "COST",
  REVENUE: "REVENUE",
};

// Per-master configuration of the shared accountant page + modal.
// `api` is the path segment under /api/cost-gl/:clinicUrl/.
// `hasRevenueGl`: the modal also asks for a revenue G/L (required).
// `writeKey`: permission to create / edit / delete the master on the page.
export const COST_GL_ENTITIES = {
  treat: {
    key: "treat",
    api: "treats",
    routeName: "CostGlTreat",
    title: "การรักษา",
    modalTitle: "รายการรักษา",
    searchPlaceholder: "ค้นหาการรักษาจากชื่อ หรือประเภท",
    successToast: "เพิ่ม Cost G/L การรักษาสำเร็จ",
    updateToast: "แก้ไข Cost G/L การรักษาสำเร็จ",
    cancelToast: "ยกเลิกการรักษาสำเร็จ",
    hasLinkedProducts: true,
    hasRevenueGl: true,
    // PROCUREMENT creates / edits / deletes the master itself on this page
    writeKey: "master_treat.write",
    deleteTitle: "ลบการรักษานี้ ?",
  },
  lab: {
    key: "lab",
    api: "labs",
    routeName: "CostGlLab",
    title: "งานแลป",
    modalTitle: "รายการแลป",
    searchPlaceholder: "ค้นหารายการแลป",
    successToast: "เพิ่ม Cost G/L งานแลปสำเร็จ",
    updateToast: "แก้ไข Cost G/L งานแลปสำเร็จ",
    cancelToast: "ยกเลิกงานแลปสำเร็จ",
    hasLinkedProducts: false,
    hasRevenueGl: false,
    writeKey: "master_lab.write",
    deleteTitle: "ลบรายการแลปนี้ ?",
  },
  item: {
    key: "item",
    api: "items",
    routeName: "CostGlItem",
    title: "ยาและสินค้า",
    modalTitle: "รายการยาและสินค้า",
    searchPlaceholder: "ค้นหายาและสินค้า จากชื่อ หรือรหัส",
    successToast: "เพิ่ม Cost G/L ยาและสินค้าสำเร็จ",
    updateToast: "แก้ไข Cost G/L ยาและสินค้าสำเร็จ",
    cancelToast: "ยกเลิกยาและสินค้าสำเร็จ",
    hasLinkedProducts: true,
    hasRevenueGl: true,
    writeKey: "master_item.write",
    deleteTitle: "ลบยาและสินค้านี้ ?",
  },
};
